import { Injectable } from "@angular/core";
import { constants } from "src/environments/constants";

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private tokenLocalStorageToken = constants.USER_KEY;

  // pagination preference

  getPaginationLocalStorage(): number | undefined {
    try {
      const lsValue = localStorage.getItem(constants.PAGINATION_PREFERENCE);
      if (!lsValue) {
        return undefined;
      }

      return +lsValue;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  setPaginationLocalStorage(pagination: number): boolean {
    // store auth authToken/refreshToken/epiresIn in local storage to keep user logged in between page refreshes
    if (pagination) {
      localStorage.setItem(
        constants.PAGINATION_PREFERENCE,
        pagination.toString()
      )
      return true;
    }
    return false;
  }

  // User data management
  
  getTokenFromLocalStorage(): string | undefined {
    try {
      const lsValue = localStorage.getItem(this.tokenLocalStorageToken);
      if (!lsValue) {
        return undefined;
      }

      return lsValue;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  setTokenFromLocalStorage(token: string): boolean {
    // store auth authToken/refreshToken/epiresIn in local storage to keep user logged in between page refreshes
    if (token) {
      localStorage.setItem(this.tokenLocalStorageToken, token)
      return true;
    }
    return false;
  }


  removeToken() {
    localStorage.removeItem(this.tokenLocalStorageToken);
  }
  //

  getLanguageFromLocalStorage(): string | undefined {
    try {
      return localStorage.getItem(constants.LANGUAGE_KEY) ?? undefined;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }
}
